<template>
  <div class="sidebarButton" v-bind:class="{ selected: link.selected }">
    <router-link v-if="!link.selected" :to="thisRoute">{{link.name}}</router-link>
    <span class="inactiveLink" v-else>{{link.name}}</span>
  </div>
</template>

<script>

export default {
  name: 'SidebarButton',
  props: {
    link: Object
  },
  computed: {
    thisRoute(){
      return { name: this.link.routeName, params: this.$route.params }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidebarButton {
    height: 55px;
    border-bottom: 2px solid #2E303A;
    display: flex;
    align-items: center;
    padding-left: 25px;
    &.selected {
      background-color: #73A9F720;
    }
  }
</style>
